var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "majesticons:file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5H6C5.20435 2.5 4.44129 2.81607 3.87868 3.37868C3.31607 3.94129 3 4.70435 3 5.5V19.5C3 20.2956 3.31607 21.0587 3.87868 21.6213C4.44129 22.1839 5.20435 22.5 6 22.5H18C18.7956 22.5 19.5587 22.1839 20.1213 21.6213C20.6839 21.0587 21 20.2956 21 19.5V11.5H15C14.2044 11.5 13.4413 11.1839 12.8787 10.6213C12.3161 10.0587 12 9.29565 12 8.5V2.5ZM21 9.5V9.328C20.9996 8.53276 20.6834 7.77023 20.121 7.208L16.293 3.378C15.7304 2.81572 14.9674 2.4999 14.172 2.5H14V8.5C14 8.76522 14.1054 9.01957 14.2929 9.20711C14.4804 9.39464 14.7348 9.5 15 9.5H21Z",
    fill: "#7E45F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedFileIcon);
export default __webpack_public_path__ + "static/media/uploaded-file-icon.dec2b594900e158f06c4b759794edf00.svg";
export { ForwardRef as ReactComponent };